module.exports = __webpack_public_path__ + "f06e6cbea9c25288dd3c307bbc6a0206.png";